import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const MRS_NEWS_SYLLABLES_ACTIVITY_FRAGMENT = gql `
  fragment MrsNewsSyllablesActivityFragment on MrsNewsSyllablesActivity {
    rounds {
      formattedText {
        formattingTool
        text
      }
      steps {
        instructions {
          id
          text
          audio {
            ...AssetFragment
          }
        }
        answer
        stepType
      }
      word
    }
  }
  ${ASSET_FRAGMENT}
`;
export default MRS_NEWS_SYLLABLES_ACTIVITY_FRAGMENT;
